import { __assign, __rest } from "tslib";
// This component renders a popover on desktop (PopoverDialog) and a modal (ModalDialog) on mobile.
import React, { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '../../Context';
import PopoverDialog from '../PopoverDialog';
import ModalDialog from '../ModalDialog';
var DialogPopup = function (_a) {
    var popoverClassName = _a.popoverClassName, props = __rest(_a, ["popoverClassName"]);
    var isMobile = useContext(MobileContext);
    var isPopover = !isMobile;
    var PopupComponent = isPopover ? PopoverDialog : ModalDialog;
    return (React.createElement(PopupComponent, __assign({ isOpen: true, className: c(isPopover && popoverClassName) }, props)));
};
DialogPopup.displayName = 'DialogPopup';
export default DialogPopup;
//# sourceMappingURL=DialogPopup.js.map